var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage7Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.653,
    height: 220.301,
    viewBox: "0 0 196.653 220.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44160",
    "data-name": "Group 44160",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9614",
    "data-name": "Path 9614",
    d: "M189.65,210.255c-.461,1.629-.863,6.238-1.5,12.216-.57,5.37-6.064,25.344-6.64,27.364-3.621,12.776-11.478,23.472-19.606,24.721-9.214,1.417-25.03,5.191-30.779,11.2-.12.124-.234.255-.348.39-5.017,6.022-7.254,16.071-18.156,17.266-10.908-1.189-13.144-11.239-18.162-17.266-.114-.136-.233-.271-.364-.4-5.755-5.994-21.554-9.767-30.763-11.184-8.133-1.249-15.99-11.418-19.611-24.2a53.882,53.882,0,0,1-1.385-6.206c-.576-3.551-4.68-16.315-5.25-21.679-.641-5.978-1.048-10.588-1.51-12.216-.776-2.742,37.62.337,77.043,4.2,39.418-3.86,77.809-6.939,77.033-4.2",
    transform: "translate(-14.392 -83.106)",
    fill: "#d3b1a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9615",
    "data-name": "Path 9615",
    d: "M187.171,227.084l-5.158,17.646s-2.715,9.5-4.615,14.388-16.017,13.845-19.818,19.545-13.644,9.35-23.107,14.312c-.391.207-.8.4-1.243.576-4.257,1.743-10.783,2.394-16.967,2.562-6.184-.169-12.71-.82-16.967-2.562-.44-.179-.852-.369-1.243-.576-9.463-4.962-19.307-8.611-23.108-14.312S57.028,264,55.128,259.118s-4.615-14.388-4.615-14.388l-5.158-17.646,70.908,5.859Z",
    transform: "translate(-18.359 -90.342)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9616",
    "data-name": "Path 9616",
    d: "M191.842,84.652C183.94,35.128,156.852.043,106.7.043H106.7C105.827.017,104.955,0,104.078,0,53.928,0,26.84,35.086,18.938,84.609c-5.682,35.608,7.664,60.256,30.224,76.5,4.224,3.041,10.762,5.159,17.193,6.964,10.318,6.524,18.253,11.9,36.513,12.554.2.008.4.013.6.017,1.058.032,2.14.053,3.269.053a26.564,26.564,0,0,0,3.407-.217c16.563-.992,24.271-6.113,34.045-12.3,6.508-1.82,13.158-3.952,17.435-7.032,22.559-16.245,35.905-40.894,30.224-76.5",
    transform: "translate(-7.135 1.571)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9617",
    "data-name": "Path 9617",
    d: "M300.517,197.9s11.792-6.373,11.792,0-10.859,19.209-14.117,24.193-12.441,7.675-12.441,7.675Z",
    transform: "translate(-115.657 -77.383)",
    fill: "#e5bfb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9618",
    "data-name": "Path 9618",
    d: "M11.791,190.6S0,184.23,0,190.6,10.858,209.812,14.116,214.8s12.441,7.674,12.441,7.674Z",
    transform: "translate(0.001 -74.43)",
    fill: "#e5bfb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9619",
    "data-name": "Path 9619",
    d: "M183.686,178.49c-.075-.114-.153-.224-.232-.33-.174-.228-.358-.436-.539-.651l0,0h0a15.608,15.608,0,0,0-1.291-1.37c-8.009-8.761-19.7-25.539-59.358-24-33.618,1.3-50.1,13.109-57.118,20.372a18.586,18.586,0,0,0-4.433,5.67h0c-7.432,13.86-6.7,40.468-6.7,40.468l20.026,20.108s1.894.634,4.7,1.542c6.079,8.794,11.572,15.6,11.572,15.6l34.35,7.832c18.478,4.213,33.82-8.324,44.062-20.81,2.049-.669,3.359-1.108,3.359-1.108L192.1,221.7s.836-30.516-8.414-43.206",
    transform: "translate(-25.06 -64.595)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9620",
    "data-name": "Path 9620",
    d: "M182.508,51.824c0,20.029-24.4,36.267-54.509,36.267S73.491,71.853,73.491,51.824,97.9,15.557,128,15.557s54.509,16.237,54.509,36.267",
    transform: "translate(-29.745 -4.726)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11609",
    "data-name": "Path 11609",
    d: "M-11895.88-1862.56c-7.959,7.1-18.165,10.683-14.255,37.614s72.6,100.272,77.75,98.533,41.968-20.517,30.94-42.454c-4.255-8.468-5.57-14.6-5.085-20.641.664-8.319,5.846-15.64,10.791-28.487,8.052-20.921-12.142-47.786-32.4-53.936S-11887.919-1869.659-11895.88-1862.56Z",
    transform: "translate(11949.55 1874.061)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11612",
    "data-name": "Path 11612",
    d: "M-11703.2-1507.6s35.719,12.219,47.457,39.124-15.768,43.051-9.9,68.98-49.3,71.911-54.682,50.385-3.912-40.6-3.912-70.933-.981-45.985,3.912-54.3S-11703.2-1507.6-11703.2-1507.6Z",
    transform: "translate(11822.216 1509.174)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11613",
    "data-name": "Path 11613",
    d: "M-11748.616-1491.747s-19.084,11.252-17.612,44.028,5.755,30.331,6.243,45.008-6.845,10.273-2.935,37.668,67.135-16.634,67.135-16.634,7.344-36.69,4.406-53.812-5.383-28.862-12.229-39.625-27.888-24.46-27.888-24.46Z",
    transform: "translate(11795.24 1514.342)",
    fill: "#efcabf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage7Top);
export default __webpack_public_path__ + "static/media/stage7_top.5c4167fec6f7e6f9be27732ad001bae7.svg";
export { ForwardRef as ReactComponent };